"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontSizeConfig = void 0;
class FontSizeConfig {
    constructor() {
    }
    static getAttributeTypeMap() {
        return FontSizeConfig.attributeTypeMap;
    }
}
exports.FontSizeConfig = FontSizeConfig;
FontSizeConfig.discriminator = undefined;
FontSizeConfig.attributeTypeMap = [
    {
        "name": "base",
        "baseName": "base",
        "type": "number",
        "format": "uint16"
    }
];
//# sourceMappingURL=FontSizeConfig.js.map